import {
  GLOBAL_SEARCH_REQUEST,
  GLOBAL_SEARCH_SUCCESS,
  GLOBAL_SEARCH_FAILURE,
  SAVE_SEARCH_HISTORY,
  SET_SELECTED_MODELS,
} from "./actions";

const initialState = {
  loading: false,
  results: {},
  error: null,
  history: [],
  selectedModels: [
    "workorders",
    "equipment",
    "electricity",
    "gas",
    "files",
    "functionaltesting",
    "comments",
    "scenarios",
  ],
};

const GlobalSearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case GLOBAL_SEARCH_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GLOBAL_SEARCH_SUCCESS:
      return {
        ...state,
        loading: false,
        results: action.payload,
        error: null,
      };
    case GLOBAL_SEARCH_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case SAVE_SEARCH_HISTORY:
      // Limit history to last 10 searches and prevent duplicates
      const duplicateIndex = state.history.findIndex(
        (item) => item.query === action.payload.query
      );

      let newHistory;
      if (duplicateIndex !== -1) {
        // Remove the duplicate and add the new search to the start
        newHistory = [
          action.payload,
          ...state.history.slice(0, duplicateIndex),
          ...state.history.slice(duplicateIndex + 1),
        ].slice(0, 10);
      } else {
        // Just add the new search to the start
        newHistory = [action.payload, ...state.history].slice(0, 10);
      }

      return {
        ...state,
        history: newHistory,
      };
    case SET_SELECTED_MODELS:
      return {
        ...state,
        selectedModels: action.payload,
      };
    default:
      return state;
  }
};

export default GlobalSearchReducer;
